//@ts-check

import { Theme } from '../../@types/windowshopify';
import isbot from 'isbot';

// naive check / fallback (intentionally errs on the side of caution)
let isProduction = window.location.hostname !== 'localhost';
let themeInfo: Theme | null = null;
let isLocal: boolean;
let isPreviewTheme: boolean;
let isReleaseCandidateTheme: boolean = false;
let apolloCacheKeySegment: string = '';
let isAvailableColorsMetafieldStale = true;

// ? [REVISIT] better name customer is not part of siteSettings
export const SiteSettings = window?.getSiteSettings?.() ?? {};

export const isPasswordProtectionEnabled = SiteSettings?.isPasswordProtectionEnabled ?? true;

export const isDevShop = 'alo-yoga.myshopify.com' !== window.Shopify.shop;
export const isBot = isbot(window.navigator.userAgent);

try {
  const { role, name } = window.Shopify.theme || {};
  isProduction = role === 'main';
  isLocal = process.env.NODE_ENV === 'development';
  isPreviewTheme = role === 'unpublished' && !isLocal;
  // ? [REVISIT] could use more strict check w/ regex
  isReleaseCandidateTheme = !isProduction && (name ? name.includes('Prod v') || name.includes('Staging') : false);
  apolloCacheKeySegment = SiteSettings?.apolloCacheKey || '';
  if ('boolean' === typeof SiteSettings?.plpEnableSwatches)
    isAvailableColorsMetafieldStale = SiteSettings?.plpEnableSwatches;
} catch (err) {
  console.error(err);
}

export {
  apolloCacheKeySegment,
  isProduction,
  themeInfo,
  isLocal,
  isPreviewTheme,
  isReleaseCandidateTheme,
  isAvailableColorsMetafieldStale,
};

let productServiceHostNameEnvVariable =
  process.env.REACT_APP_PRODUCT_SERVICE_HOST === '' ? null : process.env.REACT_APP_PRODUCT_SERVICE_HOST;
if (!isProduction && !isReleaseCandidateTheme) {
  if (!productServiceHostNameEnvVariable?.includes('.dev') && !productServiceHostNameEnvVariable?.includes('.qa')) {
    productServiceHostNameEnvVariable = productServiceHostNameEnvVariable?.replace('.alo.software', '.qa.alo.software');
  }
}
export const PRODUCT_SERVICE_HOSTNAME = productServiceHostNameEnvVariable;

export const isProductServiceAvailable = Boolean(PRODUCT_SERVICE_HOSTNAME);

// ? [REVISIT] theme settings
// ? [REVISIT] we need to crash in the absense of certain compile time variables
// ? [REVISIT] or we need to make our app okay with these being optional
const { REACT_APP_SPECIAL_VARIANTS_ALOMOVES } = process.env;

export const BUILDER_API_KEY = SiteSettings?.dev2BuilderEnvEnabled
  ? process.env.REACT_APP_BUILDER_DEV2_API_KEY
  : process.env.REACT_APP_BUILDER_API_KEY;

// ? [REVISIT] is the AM experience purely cosmetic? do we stil add the sku
export const ALO_MOVES = {
  handle: 'alo-moves-30-days-free-gift-with-purchase',
  variantId: parseInt(REACT_APP_SPECIAL_VARIANTS_ALOMOVES || '13160304345206'),
};

export const Customer = { email: SiteSettings?.customerEmail, id: SiteSettings?.customerID };

export const InitialUrlSearchParams = new URLSearchParams(window.location.search);
